// import { Api } from '@mui/icons-material';
import axios from 'axios';

const API_BASE_URL =
  process.env.REACT_APP_API_URL || 'http://localhost:5001';

const API = axios.create({
  baseURL: API_BASE_URL,
});



async function getMsToken() {
  try {
    const ms = typeof window !== 'undefined' ? window.$memberstackDom : null;

    // Some builds expose getMemberCookie synchronously; others as a promise.
    if (ms && typeof ms.getMemberCookie === 'function') {
      const maybe = ms.getMemberCookie();
      const token = (maybe && typeof maybe.then === 'function') ? await maybe : maybe;
      // if (token) return token;
      if (typeof token === 'string' && token.split('.').length === 3) return token;
    }

    // Fallback: read the cookie (_ms-mid) if present
    // if (typeof document !== 'undefined') {
    //   const m = document.cookie.match(/(?:^|;\s*)_ms-mid=([^;]+)/);
    //   if (m) return decodeURIComponent(m[1]);
    // }
  } catch (e) {
    // swallow; just return null if anything fails
  }
  return null;
}

/** Attach Authorization: Bearer <token> to every request (if available) */
API.interceptors.request.use(async (config) => {
  const token = await getMsToken();

  config.headers = config.headers || {};
  
  if (token) config.headers.Authorization = `Bearer ${token}`;
  else delete config.headers.Authorization;

  return config;
}, (error) => Promise.reject(error));


export const fetchAutocomplete = () => API.get(`/search/autocomplete`);
export const fetchSearchResults = (searchTerm) => API.get(`/search?searchTerm=${encodeURIComponent(searchTerm)}`);
export const fetchSideEffects  = (genericName) => API.get(`/openai/sideeffects?genericName=${encodeURIComponent(genericName)}`);
export const deleteUser = (details) => API.delete('/auth/deleteUser', { data: details });
export const updateUser = (updatedData) => API.patch('/auth/updateUser', updatedData);
export const updateUserDetails = (details) => API.patch('/auth/updateUserDetails', details);
export const createSubscription = (payload) => API.post('/payhere/subscribe', payload);
export const changePaymentMethod = (payload) => API.post('/auth/changePaymentMethod', payload, { responseType: 'text' });

// export const fetchMedicines = () => API.get('/products');
export const fetchInventory = (params = {}) => API.get('/products', { params });
export const addInventory = (details) => API.post('/products', details);
export const updateInventory = (id, updates) => API.patch(`/products/${id}`, updates);
export const deleteInventory = (id) => API.delete(`/products/${id}`);
export const restockInventory = (id, body) => API.post(`/products/${id}/restock`, body);
export const adjustStock = (id, body) => API.patch(`/products/${id}/adjuststock`, body);
export const fetchStockMovements = (inventoryId, limit = 50) =>
  API.get('/products/stock-movements', {
    params: { inventoryId, limit },
  });
export const fetchNotifications = () => API.get('/notifications');
export const markRead = (notificationIds) => API.post('/notifications/markRead', { notificationIds });
export const markUnread = (ids) => API.post('/notifications/markUnread', { notificationIds: ids });

export const fetchUnreadCount = () => API.get('/notifications/count');

export const fetchDashboardSummary = () => API.get('/dashboard/summary');

export const addSale = (details) => API.post('/sales', details);
export const fetchSales = (params = {}) => API.get('/sales', { params });

export const fetchAccess = () => API.get('/auth/access');

export const fetchSalesSummaryReport = (params = {}) =>
  API.get('/reports/sales-summary', { params });

export const fetchProfitReport = (params = {}) =>
  API.get('/reports/profit-summary', { params });

export const fetchInventoryReport = () =>
  API.get('/reports/inventory-summary');

export const fetchStockPerformanceReport = (params) =>
  API.get('/reports/stock-performance', { params });

export const fetchExpiryReport = (params) =>
  API.get('/reports/expiry-summary', { params });

export const fetchLowStockReport = (params) =>
  API.get("/reports/low-stock-summary", { params });